<template>
  <div>
    <v-row class="px-2 pt-2">
      <!-- Merchant -->
      <v-col md="2" class="py-0">
        <v-autocomplete
          v-model="merchant"
          label="Select a merchant"
          :items="merchants"
          item-value="merchantId"
          item-text="merchantName"
          dense
          return-object
          clearable
          @change="
            getReport();
            loading = true;
          "
          @click:clear="clearMerchant()"
        ></v-autocomplete>
      </v-col>

      <!-- Status -->
      <v-col md="2" class="py-0">
        <v-select
          v-model="search.status"
          dense
          :items="statusOptions"
          label="Status"
          append-icon="mdi-magnify"
          class="mt-0 pt-1"
          @change="getReport"
        ></v-select>
      </v-col>

      <!-- Reference -->
      <v-col md="2" class="py-0">
        <v-text-field
          v-model="search.reference"
          append-icon="mdi-magnify"
          label="Reference"
          clearable
          class="mt-0 pt-1"
          @change="getReport()"
          @click:clear="
            search.reference = null;
            getReport();
          "
        ></v-text-field>
      </v-col>

      <!-- Arrears -->
      <v-col md="2" class="py-0">
        <v-select
          v-model="search.arrears"
          dense
          :items="arrearsOptions"
          label="Arrears"
          append-icon="mdi-magnify"
          class="mt-0 pt-1"
          @change="getReport"
        ></v-select>
      </v-col>

      <!-- Frequency -->
      <v-col md="2" class="py-0">
        <v-select
          v-model="search.freq"
          dense
          :items="freqOptions"
          label="Frequency"
          append-icon="mdi-magnify"
          class="mt-0 pt-1"
          @change="getReport"
        ></v-select>
      </v-col>

      <!-- Unique Client -->
      <v-col md="2" class="py-0">
        <v-select
          v-model="search.uniqueClient"
          dense
          :items="uniqueClientOptions"
          label="Unique Client"
          append-icon="mdi-magnify"
          class="mt-0 pt-1"
          @change="getReport"
        ></v-select>
      </v-col>

      <!-- From Date -->
      <v-col md="2">
        <v-menu
          v-model="fromDateModal"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          ><template v-slot:activator="{ on }">
            <v-text-field
              v-model="search.fromDate"
              label="From Date"
              append-icon="mdi-calendar"
              readonly
              v-on="on"
              class="mt-0 pt-0"
            ></v-text-field
          ></template>
          <v-date-picker
            v-model="search.fromDate"
            @input="fromDateModal = false"
            @click:date="handleDateFilters"
            @change="getReport"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <!-- To Date -->
      <v-col md="2">
        <v-menu
          v-model="toDateModal"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          ><template v-slot:activator="{ on }">
            <v-text-field
              v-model="search.toDate"
              label="To Date"
              append-icon="mdi-calendar"
              readonly
              v-on="on"
              class="mt-0 pt-0"
            ></v-text-field
          ></template>
          <v-date-picker
            v-model="search.toDate"
            @input="toDateModal = false"
            @click:date="handleDateFilters"
            @change="getReport"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col align="end" class="">
        <v-btn small dark color="primary" class="mb-3" @click="downloadReport"
          ><v-icon>mdi-arrow-down-bold</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="px-4">
      <v-col md="12" class="pa-2">
        <v-data-table
          v-if="report"
          :headers="headers"
          :items="report"
          :items-per-page="10"
          class="elevation-0"
        >
          <template v-slot:item.status="{ item }">
            <v-icon v-if="item.status == 1" color="green" size="14">
              mdi-check-circle
            </v-icon>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-if="item.status == 0" color="red" size="14" v-on="on">
                  mdi-close-circle
                </v-icon>
              </template>
              <span v-if="item.cancelledByName"
                >Cancelled By: {{ item.cancelledByName }}</span
              >
              <span v-else>Cancelled By: SYSTEM</span>
            </v-tooltip>
          </template>
          <template v-slot:item.firstName="{ item }">
            <span v-if="merchant.merchantId == 'Test-TP-270588'"
              >Test First Name</span
            >
            <span v-else>{{ item.firstName }}</span>
          </template>
          <template v-slot:item.surname="{ item }">
            <span v-if="merchant.merchantId == 'Test-TP-270588'"
              >Test Surname</span
            >
            <span v-else>{{ item.surname }}</span>
          </template>
          <template v-slot:item.merchantCustomerId="{ item }">
            <span v-if="merchant.merchantId == 'Test-TP-270588'"
              >Test Reference</span
            >
            <span v-else>{{ item.merchantCustomerId }}</span>
          </template>
          <template v-slot:item.clientId="{ item }">
            <span v-if="merchant.merchantId == 'Test-TP-270588'"
              >Test Client ID</span
            >
            <span v-else
              ><router-link :to="`/client/${item.clientId}`">{{
                item.clientId
              }}</router-link></span
            >
          </template>
          <template v-slot:item.amount="{ item }">
            {{ item.amount }}
          </template>
          <template v-slot:item.arrears="{ item }">
            {{ item.arrears }}
          </template>
          <template v-slot:item.currency="{ item }">
            {{ item.currency }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      merchants: null,
      merchant: {},
      search: { status: null, arrears: null, uniqueClient: 0 },
      loading: true,
      report: null,
      fromDateModal: false,
      toDateModal: false,
      headers: [
        { text: "Status", value: "status", sortable: false, align: "center" },
        { text: "Schedule ID", value: "id", sortable: false, align: "center" },
        { text: "First Name", value: "firstName", sortable: false },
        { text: "Surname", value: "surname", sortable: false },
        { text: "Reference", value: "merchantCustomerId", sortable: false },
        {
          text: "Client ID",
          value: "clientId",
          sortable: false,
          align: "center",
        },
        { text: "Product", value: "productName", sortable: false },
        { text: "Frequency", value: "frequency", sortable: false },
        { text: "Collection Day", value: "collectionDay", sortable: false },
        { text: "Amount", value: "amount", sortable: false, align: "center" },
        { text: "Arrears", value: "arrears", sortable: false, align: "center" },
        {
          text: "Currency",
          value: "currency",
          sortable: false,
          align: "center",
        },
        { text: "Prev Execution", value: "previousExecution", sortable: false },
        { text: "Next Execution", value: "nextExecution", sortable: false },
      ],
      statusOptions: [
        { value: null, text: "All" },
        { value: 1, text: "Active" },
        { value: 0, text: "Terminated" },
      ],
      arrearsOptions: [
        { value: null, text: "All" },
        { value: 0, text: "No Arrears" },
        { value: 0.01, text: "Arrears" },
      ],
      uniqueClientOptions: [
        { value: 1, text: "Yes" },
        { value: 0, text: "No" },
      ],
      freqOptions: [
        { value: null, text: "All" },
        { value: "Weekly", text: "Weekly" },
        { value: "Monthly", text: "Monthly" },
        { value: "Fortnightly", text: "Fortnightly" },
        { value: "Four Weekly", text: "Four Weekly" },
      ],
    };
  },
  beforeMount() {
    this.getMerchants();
    this.getReport();
  },
  methods: {
    getMerchants() {
      if (this.$store.state.user.user_role.id <= 3) {
        axios({
          method: "get",
          url: `get-crm-merchants-live`,
          config: {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          },
        })
          .then((response) => {
            console.log(response.data);
            this.merchants = response.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else if (this.$store.state.user.user_role.id > 3) {
        axios({
          method: "post",
          url: `get-crm-merchants-live-client`,
          data: { userId: this.$store.state.user.id },
          config: {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          },
        })
          .then((response) => {
            this.merchants = response.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
      }
    },
    getReport() {
      this.loading = true;

      axios({
        method: "post",
        url: `get-schedules-report`,
        data: {
          merchant:
            typeof this.merchant !== "undefined"
              ? this.merchant.merchantId
              : null,
          search: this.search,
        },
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      })
        .then((response) => {
          this.report = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    clearMerchant() {
      console.log(this.merchant);
    },
    handleDateFilters() {
      if (this.search.toDate < this.search.fromDate) {
        this.search.fromDate = this.search.toDate;
      }
      return this.$emit("search", this.search);
    },
    downloadReport() {
      this.loading = true;

      axios({
        url: `get-schedules-report`,
        method: "post",
        data: {
          merchant:
            typeof this.merchant !== "undefined"
              ? this.merchant.merchantId
              : null,
          search: this.search,
          download: true,
        },
        responseType: "blob",
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "schedules-report.csv");
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
};
</script>

<style></style>
